import { createSlice } from "@reduxjs/toolkit";

const agenda = createSlice({
  name: "agenda",
  initialState: {
    data: [],
    isLoading: true,
    error: null,
    pagination: { page: 1, lastPage: 1 },
  },
  reducers: {
    setAgenda: (state, action) => {
      state.data = action.payload.data;
      state.isLoading = action.payload.isLoading;
      state.error = action.payload.error;
      state.pagination = action.payload.pagination;
    },
  },
});

export const { setAgenda } = agenda.actions;
export default agenda.reducer;
